import { useState, useCallback } from "react";
import { deleteCustomerGroup } from "@api";

export function useGroupDelete() {
  const [deleting, setDeleting] = useState(false);

  const deleteGroup = useCallback(async (groupId) => {
    if (!groupId) {
      console.error("No groupId provided for deletion");
      return false;
    }

    setDeleting(true);
    try {
      const success = await deleteCustomerGroup(groupId);
      if (!success) {
        console.error("Failed to delete group:", groupId);
        return false;
      }
      return true;
    } catch (error) {
      console.error("Error deleting group:", error);
      return false;
    } finally {
      setDeleting(false);
    }
  }, []);

  return {
    deleting,
    deleteGroup,
  };
}
